//Announcement bar above menu slider

document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.cc-announcement-slider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.cc-announcement-slider__slide');
  const prevArrow = slider.querySelector('.cc-announcement-slider__nav--prev');
  const nextArrow = slider.querySelector('.cc-announcement-slider__nav--next');
  const autoRotate = slider.getAttribute('data-auto-rotate') === 'true';
  const sliderSpeed = parseInt(slider.getAttribute('data-slider-speed'), 10) * 1000 || 5000;

  let currentIndex = 0;
  let autoRotateInterval;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.style.opacity = '0';
      slide.style.display = 'none';
      slide.classList.remove('visible');
    });

    slides[index].style.display = 'block';
    setTimeout(() => {
      slides[index].style.opacity = '1';
      slides[index].classList.add('visible');
    }, 10); // Slight delay to allow opacity transition
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  }

  function prevSlide() {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    showSlide(currentIndex);
  }

  function startAutoRotate() {
    stopAutoRotate(); // Clear any existing interval to avoid multiple intervals running.
    if (autoRotate && slides.length > 1) {
      autoRotateInterval = setInterval(nextSlide, sliderSpeed);
    }
  }

  function stopAutoRotate() {
    clearInterval(autoRotateInterval);
  }

  if (nextArrow) {
    nextArrow.addEventListener('click', () => {
      nextSlide();
      startAutoRotate(); // Restart the timer after manual interaction
    });
  }

  if (prevArrow) {
    prevArrow.addEventListener('click', () => {
      prevSlide();
      startAutoRotate(); // Restart the timer after manual interaction
    });
  }

  // Start the slider initially
  showSlide(currentIndex);
  startAutoRotate();
});

// Back button with scroll position memory
(function() {
  var SCROLL_STORAGE_KEY = 'betseys_scroll_positions';

  function getScrollPositions() {
    try {
      var data = sessionStorage.getItem(SCROLL_STORAGE_KEY);
      return data ? JSON.parse(data) : {};
    } catch (e) {
      return {};
    }
  }

  function saveScrollPosition() {
    try {
      var positions = getScrollPositions();
      positions[window.location.href] = window.scrollY || window.pageYOffset;
      sessionStorage.setItem(SCROLL_STORAGE_KEY, JSON.stringify(positions));
    } catch (e) {}
  }

  function restoreScrollPosition() {
    try {
      var positions = getScrollPositions();
      var savedPosition = positions[window.location.href];
      if (typeof savedPosition === 'number') {
        setTimeout(function() {
          window.scrollTo(0, savedPosition);
        }, 100);
      }
    } catch (e) {}
  }

  function isSameOrigin(url) {
    try {
      var link = document.createElement('a');
      link.href = url;
      return link.hostname === window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  // Save scroll position before leaving the page
  window.addEventListener('beforeunload', saveScrollPosition);

  // Save scroll position on same-origin link clicks
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a');
    if (link && link.href && isSameOrigin(link.href)) {
      saveScrollPosition();
    }
  });

  // Restore scroll position on page load
  document.addEventListener('DOMContentLoaded', function() {
    restoreScrollPosition();

    // Back button click handler
    var prevArrow = document.querySelector('.cc-announcement-slider__nav--prev');
    if (prevArrow) {
      prevArrow.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var referrer = document.referrer;
        if (referrer && isSameOrigin(referrer)) {
          window.history.back();
        } else {
          window.location.href = '/collections/all';
        }
      });
    }
  });
})();

class ProductGroupingSwatches extends HTMLElement {
  constructor() {
    super();
    this.handleVariantChange = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;

    this.productArea = this.closest('.product-area');
    this.currentProductId = String(this.dataset.currentProductId);
    this.colorOptionName = this.normalizeOptionName(this.dataset.colorOptionName);
    this.products = new Map();

    this.querySelectorAll('[data-grouped-product-json]').forEach((element) => {
      try {
        const productData = JSON.parse(element.textContent);
        this.products.set(String(productData.id), productData);
      } catch (error) {
        return;
      }
    });

    this.currentProduct = this.products.get(this.currentProductId);
    if (!this.productArea || !this.currentProduct) return;

    this.initialized = true;
    this.productArea.addEventListener('change', this.handleVariantChange);
    this.updateFromCurrentSelection();
  }

  disconnectedCallback() {
    if (this.productArea) {
      this.productArea.removeEventListener('change', this.handleVariantChange);
    }
    this.initialized = false;
  }

  normalizeOptionName(optionName) {
    return String(optionName || '').trim().toLowerCase();
  }

  getOptionNames(productData) {
    return (productData.options || []).map((option) => {
      return this.normalizeOptionName(typeof option === 'string' ? option : option.name);
    });
  }

  getCurrentVariant(variantId) {
    const variants = this.currentProduct.variants || [];
    return variants.find((variant) => String(variant.id) === String(variantId));
  }

  updateFromCurrentSelection() {
    const variantInput = this.productArea.querySelector('select.original-selector[name="id"]') ||
      this.productArea.querySelector('[name="id"]');
    const variantFromUrl = new URL(window.location.href).searchParams.get('variant');
    const currentVariant = this.getCurrentVariant(variantInput ? variantInput.value : variantFromUrl) ||
      (this.currentProduct.variants || []).find((variant) => variant.available) ||
      (this.currentProduct.variants || [])[0];

    if (currentVariant) {
      this.updateSwatches(currentVariant);
    }
  }

  getSelectedOptions(currentVariant) {
    const selectedOptions = new Map();
    const optionNames = this.getOptionNames(this.currentProduct);

    optionNames.forEach((optionName, index) => {
      if (optionName && optionName !== this.colorOptionName && currentVariant.options[index] != null) {
        selectedOptions.set(optionName, currentVariant.options[index]);
      }
    });

    return selectedOptions;
  }

  getSelectedOptionsFromControls() {
    const selectedOptions = new Map();

    this.productArea.querySelectorAll('.option-selectors .selector-wrapper[data-option-name]').forEach((wrapper) => {
      const optionName = this.normalizeOptionName(wrapper.dataset.optionName);
      const select = wrapper.querySelector('select');

      if (optionName && optionName !== this.colorOptionName && select) {
        selectedOptions.set(optionName, select.value);
      }
    });

    return selectedOptions;
  }

  findMatchingVariant(productData, selectedOptions) {
    const variants = productData.variants || [];
    const optionNames = this.getOptionNames(productData);
    const sharedOptions = [];

    selectedOptions.forEach((value, optionName) => {
      const optionIndex = optionNames.indexOf(optionName);
      if (optionIndex !== -1) {
        sharedOptions.push({ optionIndex, value });
      }
    });

    if (sharedOptions.length === 0) {
      return variants.find((variant) => variant.available) || variants[0] || null;
    }

    const matchingVariants = variants.filter((variant) => {
      return sharedOptions.every(({ optionIndex, value }) => variant.options[optionIndex] === value);
    });

    if (matchingVariants.length === 0) return null;
    return matchingVariants.find((variant) => variant.available) || matchingVariants[0];
  }

  buildVariantUrl(productUrl, variant) {
    const url = new URL(productUrl, window.location.origin);
    if (variant) {
      url.searchParams.set('variant', variant.id);
    } else {
      url.searchParams.delete('variant');
    }
    return `${url.pathname}${url.search}${url.hash}`;
  }

  updateSwatches(currentVariant, selectedOptionsOverride) {
    const selectedOptions = selectedOptionsOverride || this.getSelectedOptions(currentVariant);

    this.querySelectorAll('[data-grouped-product-id]').forEach((swatch) => {
      const productId = String(swatch.dataset.groupedProductId);
      const productData = this.products.get(productId);
      if (!productData) return;

      const matchingVariant = productId === this.currentProductId && currentVariant ?
        currentVariant :
        this.findMatchingVariant(productData, selectedOptions);
      const unavailable = !matchingVariant || !matchingVariant.available;

      swatch.classList.toggle('unavailable', unavailable);
      const unavailableLabel = swatch.querySelector('[data-grouped-product-unavailable]');
      if (unavailableLabel) {
        unavailableLabel.hidden = !unavailable;
      }

      if (swatch.matches('a')) {
        if (matchingVariant) {
          swatch.href = this.buildVariantUrl(swatch.dataset.productUrl, matchingVariant);
          swatch.removeAttribute('aria-disabled');
        } else {
          swatch.removeAttribute('href');
          swatch.setAttribute('aria-disabled', 'true');
        }
      }
    });
  }

  handleVariantChange(event) {
    if (!(event.target instanceof Element) || !event.target.matches('[name="id"]')) return;

    if (event.detail === false) {
      this.updateSwatches(null, this.getSelectedOptionsFromControls());
      return;
    }

    const eventVariant = event.detail && Array.isArray(event.detail.options) ? event.detail : null;
    const currentVariant = eventVariant || this.getCurrentVariant(event.target.value);
    if (currentVariant) {
      this.updateSwatches(currentVariant);
    }
  }
}

if (!customElements.get('product-grouping-swatches')) {
  customElements.define('product-grouping-swatches', ProductGroupingSwatches);
}
